import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import { ClassificationSidebar } from './components/ClassificationSidebar';
import { SidebarView } from '../../component/sidebar-view/SidebarView';
import { ClassificationProvider } from './context/ClassificationContext';

export const ClassificationPage = () => {
  return (
    <ClassificationProvider>
      <Box sx={{ display: 'flex', height: '100%', gap: 2 }}>
        <SidebarView sidebar={<ClassificationSidebar />}>
          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Outlet />
          </Box>
        </SidebarView>
      </Box>
    </ClassificationProvider>
  );
};

export default ClassificationPage;
